import {
  CareShareActivity,
  CareShareYear,
  TCareAndShareMinhBachArticle,
} from '@/types/care-and-share'

export const CareShareFormatter = {
  formatMinhBachArticlesToYears: (
    articles: TCareAndShareMinhBachArticle[]
  ): CareShareYear[] => {
    if (!articles || articles.length === 0) return []

    // Group articles by year from publish_date
    const articlesByYear = articles.reduce(
      (acc, article) => {
        const year = new Date(article.publish_date).getFullYear().toString()
        if (!acc[year]) {
          acc[year] = []
        }
        acc[year].push(article)
        return acc
      },
      {} as Record<string, TCareAndShareMinhBachArticle[]>
    )

    // Transform to CareShareYear format
    return Object.entries(articlesByYear)
      .sort(([yearA], [yearB]) => parseInt(yearB) - parseInt(yearA)) // Sort descending
      .map(([year, yearArticles]) => ({
        year,
        activities: yearArticles.map((article, index) => {
          const formatDate = (dateStr: string) => {
            const date = new Date(dateStr)
            return `${String(date.getDate()).padStart(2, '0')}/${String(
              date.getMonth() + 1
            ).padStart(2, '0')}/${date.getFullYear()}`
          }

          return {
            id: `${year}-${article.title.toLowerCase().replace(/\s+/g, '-')}-${index}`,
            title: article.title,
            dateRange:
              article.end_date && article.end_date.trim()
                ? `${formatDate(article.start_date)} - ${formatDate(article.end_date)}`
                : formatDate(article.start_date),
            description: article.description,
            banner:
              article.slides && article.slides.length > 0
                ? `https://mcdn.coolmate.me${article.slides[0].path}`
                : `https://mcdn.coolmate.me${article.logo}`,
            bannerAlt: article.slides?.[0]?.description || article.title,
            partners: article.logo
              ? [
                  {
                    name: article.title,
                    logo: `https://mcdn.coolmate.me${article.logo}`,
                    alt: article.title,
                  },
                ]
              : undefined,
            images:
              article.slides && article.slides.length > 0
                ? article.slides.map((img) => ({
                    path: img.path,
                    description: img.description,
                  }))
                : undefined,
          } satisfies CareShareActivity
        }),
      })) satisfies CareShareYear[]
  },
}
